/*
 * @Author: Dom
 * @Date: 2022-06-21 10:23:04
 * @LastEditTime: 2022-06-23 17:44:32
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\account\accountquery\locales\zh-CN.ts
 */
export default {
    'page.account.accountquery.overview': '帐户总览',
    'page.account.accountquery.primaryAccountNumber': '登录账号',
    'page.account.accountquery.code': '客户编号',
    'page.account.accountquery.date': '注册日期',
    'page.account.accountquery.type': '账户类型',
    'page.account.accountquery.account': '账户总额',
    'page.account.accountquery.cash': '现金总额',
    'page.account.accountquery.credit': '信用总额',
    'page.account.accountquery.frozen': '冻结金额',
    'page.account.accountquery.used': '已用总额',
    'page.account.accountquery.bills': '未付账单',
    'page.account.accountquery.deduction': '未生成账单(扣费)',
    'page.account.accountquery.frozenD': '未生成账单(冻结)',
    'page.account.accountquery.balance': '可用余额',
    'page.account.accountquery.details': '查看物流单费用明细',
    'page.account.accountquery.cashBalance': '现金余额',
    'page.account.accountquery.limit': '信用额度',
    'page.account.accountquery.deductionDetails': '费用明细',
    'page.account.accountquery.inquiry': '账单查询',
    'page.account.accountquery.prepaid': '预付账户',
    'page.account.accountquery.period': '账期账户',
    'page.account.accountquery.viewRechargeDetails': '查看充值明细',
    'page.account.accountquery.viewFrozenDetails': '查看冻结明细',
    'page.account.accountquery.search': '查询',
    'page.account.accountquery.expense': '费用发生时间',
    'page.account.accountquery.datez': '账单生成日期',
    'page.account.accountquery.billcode': '账单编号',
    'page.account.accountquery.cycle': '账单周期',
    'page.account.accountquery.amount': '账单金额',
    'page.account.accountquery.currency': '币种',
    'page.account.accountquery.dueDate': '账单到期付款日',
    'page.account.accountquery.status': '账单状态',
    'page.account.accountquery.detailsZ': '账单详情',
    'page.account.accountquery.waybillNo': '物流单',
    'page.account.accountquery.weight': '实际重量(g)',
    'page.account.accountquery.volume': '体积重量(g)',
    'page.account.accountquery.volumeZ': '体积(cm)',
    'page.account.accountquery.billingWeight': '计费重量(g)',
    'page.account.accountquery.expenseType': '费用类型',
    'page.account.accountquery.expenseProject': '费用项目',
    'page.account.accountquery.deductionAmount': '扣费金额',
    'page.account.accountquery.products': '产品名称',
};
